import type { SVGProps } from 'react';

const StarAIIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99967 19.1673C4.53944 19.1673 4.16634 18.7942 4.16634 18.334C4.16634 17.8737 4.53944 17.5007 4.99967 17.5007C5.45991 17.5007 5.83301 17.8737 5.83301 18.334C5.83301 18.7942 5.45991 19.1673 4.99967 19.1673Z"
      fill="url(#paint0_linear_5609_26443)"
    />
    <path
      d="M14.9997 2.50065C14.5394 2.50065 14.1663 2.12756 14.1663 1.66732C14.1663 1.20708 14.5394 0.833984 14.9997 0.833984C15.4599 0.833984 15.833 1.20708 15.833 1.66732C15.833 2.12756 15.4599 2.50065 14.9997 2.50065Z"
      fill="url(#paint1_linear_5609_26443)"
    />
    <path
      d="M18.333 5.83398C17.8728 5.83398 17.4997 5.46089 17.4997 5.00065C17.4997 4.54041 17.8728 4.16732 18.333 4.16732C18.7932 4.16732 19.1663 4.54041 19.1663 5.00065C19.1663 5.46089 18.7932 5.83398 18.333 5.83398Z"
      fill="url(#paint2_linear_5609_26443)"
    />
    <path
      d="M8.91197 4.18945C9.18856 3.04883 10.8108 3.04883 11.0874 4.18945L11.8484 7.32796C11.9472 7.7352 12.2651 8.05316 12.6724 8.15191L15.8109 8.91295C16.9515 9.18954 16.9515 10.8118 15.8109 11.0884L12.6724 11.8494C12.2651 11.9481 11.9472 12.2661 11.8484 12.6733L11.0874 15.8118C10.8108 16.9525 9.18856 16.9525 8.91197 15.8119L8.15093 12.6733C8.05218 12.2661 7.73422 11.9481 7.32698 11.8494L4.18848 11.0884C3.04785 10.8118 3.04785 9.18954 4.18848 8.91295L7.32698 8.15191C7.73422 8.05316 8.05218 7.7352 8.15093 7.32796L8.91197 4.18945Z"
      fill="url(#paint3_linear_5609_26443)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5953 12.4968C18.9833 12.6416 19.1805 13.0736 19.0357 13.4617C18.0975 15.9754 16.1498 17.9945 13.6854 19.0258C13.3033 19.1858 12.8639 19.0056 12.704 18.6235C12.5441 18.2414 12.7242 17.802 13.1063 17.6421C15.1892 16.7705 16.8373 15.0618 17.6304 12.9372C17.7752 12.5491 18.2072 12.3519 18.5953 12.4968Z"
      fill="url(#paint4_linear_5609_26443)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.51699 1.40452C7.66213 1.79247 7.46529 2.22463 7.07734 2.36977C4.94096 3.16903 3.22528 4.8364 2.3601 6.94285C2.20273 7.32601 1.76455 7.50904 1.38139 7.35167C0.99824 7.1943 0.815208 6.75611 0.972579 6.37296C1.99579 3.88174 4.02299 1.91092 6.55173 0.964868C6.93969 0.819727 7.37184 1.01656 7.51699 1.40452Z"
      fill="url(#paint5_linear_5609_26443)"
    />
    <path
      d="M1.66634 15.834C1.2061 15.834 0.833008 15.4609 0.833008 15.0007C0.833008 14.5404 1.2061 14.1673 1.66634 14.1673C2.12658 14.1673 2.49967 14.5404 2.49967 15.0007C2.49967 15.4609 2.12658 15.834 1.66634 15.834Z"
      fill="url(#paint6_linear_5609_26443)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5609_26443"
        x1="0.833008"
        y1="3.41211"
        x2="20.2241"
        y2="4.04286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#700F94" />
        <stop offset="0.511934" stopColor="#9614C6" />
        <stop offset="1" stopColor="#EB2F96" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5609_26443"
        x1="0.833008"
        y1="3.41211"
        x2="20.2241"
        y2="4.04286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#700F94" />
        <stop offset="0.511934" stopColor="#9614C6" />
        <stop offset="1" stopColor="#EB2F96" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5609_26443"
        x1="0.833008"
        y1="3.41211"
        x2="20.2241"
        y2="4.04286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#700F94" />
        <stop offset="0.511934" stopColor="#9614C6" />
        <stop offset="1" stopColor="#EB2F96" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5609_26443"
        x1="0.833008"
        y1="3.41211"
        x2="20.2241"
        y2="4.04286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#700F94" />
        <stop offset="0.511934" stopColor="#9614C6" />
        <stop offset="1" stopColor="#EB2F96" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5609_26443"
        x1="0.833008"
        y1="3.41211"
        x2="20.2241"
        y2="4.04286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#700F94" />
        <stop offset="0.511934" stopColor="#9614C6" />
        <stop offset="1" stopColor="#EB2F96" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5609_26443"
        x1="0.833008"
        y1="3.41211"
        x2="20.2241"
        y2="4.04286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#700F94" />
        <stop offset="0.511934" stopColor="#9614C6" />
        <stop offset="1" stopColor="#EB2F96" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_5609_26443"
        x1="0.833008"
        y1="3.41211"
        x2="20.2241"
        y2="4.04286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#700F94" />
        <stop offset="0.511934" stopColor="#9614C6" />
        <stop offset="1" stopColor="#EB2F96" />
      </linearGradient>
    </defs>
  </svg>
);

export default StarAIIcon;
